import { FC } from "react";
import Text from "../../Text";
import { useDailyGiftContext } from "./context";

const DailyGiftName: FC = (props) => {
    const gift = useDailyGiftContext();

    if (!gift?.name) {
        return null;
    }

    return (
        <Text text={gift.name} {...props} />
    )
}

export default DailyGiftName;
